import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const getLikes = ({ fileId, userId, railsType }) =>
  axios
    .get(Routes.user_likes_path(userId), {
      params: {
        likeable_id: fileId,
        likeable_type: railsType,
      },
    })
    .then((res) => res.data);

export const getComments = ({ fileId, userId, railsType }) =>
  axios
    .get(Routes.user_comments_path(userId), {
      params: {
        commentable_id: fileId,
        commentable_type: railsType,
      },
    })
    .then((res) => res.data);
